import _styled from "styled-components";
import React from "react";
import { usePathCreator } from "../Config/useLinkCreator";
import { Header } from "../Header/Header";

var Container = _styled.div.withConfig({
  displayName: "AdvicesPage__Container",
  componentId: "d85j6j-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "AdvicesPage__Title",
  componentId: "d85j6j-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

export function AdvicesPage() {
  var pathCreator = usePathCreator();
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/help")
  }), /*#__PURE__*/React.createElement(Title, null, "\u0421\u043E\u0432\u0435\u0442\u044B \u043F\u043E \u044D\u043D\u0435\u0440\u0433\u043E\u0441\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u044E"));
}